(function () {
  var STORAGE_KEY = 'ks-launch-hide-sold-out';
  var GRID_CLASS = 'product-grid--hide-sold-out';
  var toggleBound = false;

  function readState() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeState(hide) {
    try {
      sessionStorage.setItem(STORAGE_KEY, hide ? '1' : '0');
    } catch (e) {}
  }

  function applyToGrid() {
    var grid = document.querySelector('.product-grid--launch');
    if (!grid) return;
    if (readState()) grid.classList.add(GRID_CLASS);
    else grid.classList.remove(GRID_CLASS);
  }

  function applyToToggle(toggle) {
    var hide = readState();
    toggle.setAttribute('aria-pressed', hide ? 'true' : 'false');
    if (hide) toggle.classList.add('launch-stock-toggle--on');
    else toggle.classList.remove('launch-stock-toggle--on');
  }

  function bindToggle() {
    if (toggleBound) return;
    var toggle = document.querySelector('[data-launch-stock-toggle]');
    if (!toggle) return;
    toggleBound = true;
    applyToToggle(toggle);
    toggle.addEventListener('click', function () {
      writeState(!readState());
      applyToToggle(toggle);
      applyToGrid();
    });
  }

  function relocateScrollToggle() {
    var toolbar = document.querySelector('[data-launch-toolbar]');
    if (!toolbar) return;
    var scrollToggle = document.querySelector('.ks-scroll-toggle');
    if (!scrollToggle) return;
    if (toolbar.contains(scrollToggle)) return;
    toolbar.insertBefore(scrollToggle, toolbar.firstChild);
  }

  function init() {
    bindToggle();
    applyToGrid();
    relocateScrollToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(function () {
    if (!toggleBound) bindToggle();
    applyToGrid();
    relocateScrollToggle();
  }).observe(document.body, { childList: true, subtree: true });
})();
